<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <div class="container-fluid">
      <div class="row border">
        <div class="col-12">
          <div class="titulos">
            <div class="seccionTitle">
              <em class="fa fa-picture-o mLeft"></em>
              <div class="headerTxt mLeft">Postales del Sistema</div>
            </div>
            <div>PO_01_Postales</div>
          </div>
        </div>
        <div class="col-12">
          <b-tabs content-class="mt-3 border" fill>
            <b-tab title="Lista de Postales" active>
              <listaPostales/>
            </b-tab>
            <b-tab  title="Subir Postal">
              <altaPostal/>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";

import altaPostal from "../components/postales/altaPostal.vue";
import listaPostales from "../components/postales/listaPostales.vue";

export default {
  name: "Postales",
  props: {
    msg: String,
  },
  components: {
    Header,
    listaPostales,
    altaPostal
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),

  methods: {},
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>

<style>
.nav-fill>li.nav-item > a.nav-link:hover{
  color: #FFF !important;
}
</style>
